import DataMapper from './../DataMapper'
import InsuredInfoData from '../../../models/CaseServiceData/InsuredInfoData'
import InsuredInfoDataRM from '../../responsemodel/CaseServiceDataRM/InsuredInfoDataRM'
class InsuredInfoDataMapper extends DataMapper<InsuredInfoDataRM, InsuredInfoData> {
    map = (rm: InsuredInfoDataRM) => new InsuredInfoData(rm.alternativePhone, rm.contactNumber, rm.email, rm.hospitalData, rm.insuredConfirmation, rm.investigatorName, rm.isFieldSaved, rm.occupation, rm.occupationAddress, rm.occupationId, rm.meetingPlace, rm.name, rm.insured_name, rm.relationWithInsured, rm.supportingDocuments,)
}
export default InsuredInfoDataMapper
